/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ object: NonNullable<unknown>, what: NonNullable<unknown>, saves: NonNullable<unknown> }} Bell_Follow_ActivityInputs */

const en_bell_follow_activity = /** @type {(inputs: Bell_Follow_ActivityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.object}: ${i?.what} (${i?.saves})`)
};

/**
* | output |
* | --- |
* | "{object}: {what} ({saves})" |
*
* @param {Bell_Follow_ActivityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_follow_activity = /** @type {((inputs: Bell_Follow_ActivityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Follow_ActivityInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_follow_activity(inputs)
});